module.exports = {
	methods: {
		displayMessage(message, type = 'success', duration = 3000, showClose = true) {
			if(message) {
				this.$message({
					duration: duration,
					showClose: showClose,
					message: message,
					type: type
				});
			}
		},
	}
};
